import styled from "styled-components/native";
import { Props } from "./model";

export const StyledMain = styled.View`
	background-color: rgb(20, 20, 20);
	justify-content: center;
	display: flex;
	align-items: center;
	height: 100%;
`;

export const StyledContainer = styled.View<Props>`
	display: flex;
	width: ${(props) => (props.isNarrow ? "90%" : "80%")};
	height: 62.5%;
	flex-direction: column;
	gap: 6.3125rem;
`;

export const StyledDetails = styled.View`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	align-self: stretch;
`;

export const StyledBox = styled.View`
	display: flex;
	width: 16.875rem;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	z-index: 9999;
`;

export const StlyedText = styled.Text`
	overflow: hidden;
	color: #f2f2f2;
	text-overflow: ellipsis;
	font-family: Nunito;
	font-size: 3.125rem;
	font-style: normal;
	font-weight: 500;
	line-height: 3.75rem;
`;

export const StlyedSubText = styled.Text`
	color: #f2f2f2;
	font-family: Nunito;
	font-size: 1.125rem;
	font-style: normal;
	font-weight: 300;
	line-height: 1.25rem;
`;

export const StyledPackshot = styled.View`
	width: 16.875rem;
	height: 25.25rem;
	margin-bottom: 1.5rem;
	flex-shrink: 0;
`;

export const StyledQR = styled.View`
	width: 16.875rem;
	height: 16.5rem;
	margin-top: 1.5rem;
	background-color: #fff;
	border-radius: 8px;
`;

export const StyledDeviceBox = styled.View`
	display: flex;
	height: 31.5rem;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	z-index: 9999;
`;

export const StyledButtonContainer = styled.View`
	display: flex;
	width: 23rem;
	top: 21.5rem;
	justify-content: center;
	gap: 0.625rem;
`;

/* Narrow Styles */
export const StyledDetailsNarrow = styled.View`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	align-self: stretch;
`;

export const StyledPackshotBoxNarrow = styled.View`
	display: flex;
	width: 525px;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	z-index: 9999;
`;

export const StlyedTextNarrow = styled.Text`
	overflow: hidden;
	color: #f2f2f2;
	text-overflow: ellipsis;
	font-family: Nunito;
	font-size: 40px;
	font-style: normal;
	font-weight: 500;
	line-height: 48px;
`;

export const StlyedSubTextNarrow = styled.Text`
	color: #f2f2f2;
	font-family: Nunito;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 16px;
`;

export const StyledQRNarrow = styled.View`
	width: 204.545px;
	height: 200px;
	margin-top: 1.5rem;
	background-color: #fff;
	border-radius: 8px;
`;

export const StyledPackshotNarrow = styled.View`
	width: 211px;
	height: 317px;
	margin-bottom: 1.5rem;
	flex-shrink: 0;
`;

export const StyledDeviceBoxNarrow = styled.View`
	display: flex;
	height: 324px;
	width: 368px;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	z-index: 9999;
`;

export const StyledButtonContainerNarrow = styled.View`
	display: flex;
	width: 100%;
	top: 200px;
	justify-content: center;
	gap: 0.625rem;
`;
